import React from 'react';
import { Icon } from './Icon.js';
export const IconMaskCircleFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm0,1.5c.458,0,.905,.049,1.336,.139,.099,.455,.164,.911,.164,1.361,0,3.584-2.916,6.5-6.5,6.5-.45,0-.906-.065-1.36-.164-.091-.431-.14-.878-.14-1.336,0-3.584,2.916-6.5,6.5-6.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconMaskCircleFill18.js.map